<template>
	<div>
		<v-btn color="primary" :to="{ name: 'marks', params: { classId: 'class', sectionId: 'section' } }">
			marks
		</v-btn>
	</div>
</template>

<script>
export default {
	name: 'Classes'
}
</script>

<style>

</style>